import { IconButton, Typography } from "@mui/material";
import { FaChevronLeft } from "react-icons/fa6";
import { Link } from "react-router-dom";

import noAvatarImage from "../../../imagenes/no_avatar.svg";
import { useTeachingPreview } from "../hooks/useTeachingPreview";

export function Header() {
	const { course } = useTeachingPreview();

	if (!course) {
		return;
	}

	return (
		<div className="header">
			<Link to={`/my-services/${course.courseSlug}/publishing`}>
				<IconButton className="icon-button">
					<FaChevronLeft />
				</IconButton>
			</Link>

			<img src={noAvatarImage} className="avatar" />

			<div>
				<Typography className="small-title-text bold">
					[Student Name]
				</Typography>
				<Link
					to={`/services/${course.courseSlug}`}
					target="_blank"
					className="black-text underline-on-hover-link">
					<Typography className="normal-text">{course.name}</Typography>
				</Link>
			</div>
		</div>
	);
}
